class HelpDropdow {
	constructor() {
			this.helpDropdownBtns = document.querySelectorAll('[data-dropdown=help-dropdown]');
			this.closeBtn = document.querySelector('[data-dropdown=close-help-dropdown]');
			this.helpDropdownContent = document.querySelector('[data-content=help-dropdown]');
	
			this.addListener();
	}

	addListener(input, clearBtn) {
		[].slice.call(this.helpDropdownBtns).forEach(btn => {
			btn.addEventListener('click', ()=> {
				this.helpDropdownContent.classList.toggle('br_top-header__help-dropdown--opened');
				if (this.helpDropdownContent.classList.contains('br_top-header__help-dropdown--opened')) {
					btn.setAttribute("aria-expanded", "true");
				} else {
					btn.setAttribute("aria-expanded", "false");
				}				
			});
		});

		this.closeBtn.addEventListener('click', ()=> {
			this.helpDropdownContent.classList.remove('br_top-header__help-dropdown--opened');
			[].slice.call(this.helpDropdownBtns).forEach(btn => {
				btn.setAttribute("aria-expanded", "false");
			});	
		});
	}
}

export default HelpDropdow;
